import * as actionTypes from './actionTypes'
import { handleActions } from 'redux-actions'
import { mergeValues } from '../../common/utils'

const reducers = {}

reducers[actionTypes.CONFIG_UPDATE] = {
  next (state, action) {
    return mergeValues(state, action.payload)
  }
}

reducers[actionTypes.SET_SDP_HANDLERS] = {
  next (state, action) {
    return {
      ...state,
      call: {
        ...state.call,
        sdpHandlers: action.payload.sdpHandlers
      }
    }
  }
}

// Config default state is an empty Object
const reducer = handleActions(reducers, {})
export default reducer
